























import Vue from 'vue';
export default Vue.extend({
  props: {
    canDelete: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showDeleteMessage: false
    };
  },

  methods: {
    deleteIt() {
      if (this.canDelete) {
        this.$emit('delete');
      } else {
        this.showDeleteMessage = true;
      }
    },
    hideMessage() {
      this.showDeleteMessage = false;
    }
  }
});
